@let isLoaded = isLoaded$ | async;
<pxc-zoom-container [zoomWheelCTRLBinding]="true">
  <img
    class="pointer-events-none h-full max-h-[97vh] object-contain"
    pxcImageLoad
    [hidden]="!isLoaded"
    [src]="$safeNavigationMigration(item.media?.uri)"
    (loadError)="onPictureError()"
    (loadSuccess)="onPictureLoad()" />
  @if (!isLoaded) {
    <pxc-loader [dark]="true" />
  }
</pxc-zoom-container>
